import styled from '@emotion/styled';

export const AboutContainer = styled.section`
    display: flex;
    width: 100% !important;
    flex-direction: column;
    gap: 2rem;
    align-items: flex-start;

    @media (max-width: 768px) {
        h2 {
            line-height: 1;
            margin-bottom: 0.5rem;
        }
    }

    p {
        max-width: 600px;
        font-size: 1.1rem;
        line-height: 1.6;
        margin: 0;
    }
`;

export const CTAButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin-top: 1rem;
    width: 100%;
`;

export const CTAButton = styled.a<{
    variant?: 'primary' | 'secondary' | 'tertiary';
}>`
    width: fit-content;
    // min-width: 180px;
    padding: 0.75rem 1.5rem;
    background-color: transparent;
    color: var(--primary-color) !important;
    border: 2px solid var(--primary-color);

    border-radius: 50px;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.2s ease;
    white-space: nowrap;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;

    &:hover {
        background-color: var(--primary-color);
        color: white !important;
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(20, 128, 238, 0.2);
    }

    @media (max-width: 900px) {
        width: 100%;
        min-width: unset;
        justify-content: center;
    }
`;

export const SocialLinks = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-top: 1rem;
    align-items: center;

    a {
        color: var(--text-color);
        transition: color 0.3s ease;

        &:hover {
            color: var(--primary-color);
        }
    }
`;
